import styled from "styled-components";

export const RequiredSterickStyled = styled.div`
  color: ${({ theme }): string => theme?.textColors?.RED_16};
`;
